import './obbligazioni-table.scss';

export class ObbligazioniTable {}
